module.exports = __webpack_public_path__ + "img/menu2.dde62b32.svg";